export const GOOGLE_SITE_KEY = '6LdEFtkZAAAAAM6MUKlfM67N4J9LIbD_huhW0BmE';

export const FORMSPREE_URL = 'https://formspree.io/f/mvovaobd';